import { Box, Button, Grid } from "@mui/material";
import React, { useEffect } from "react";
import "./Quiz.css";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo_quick-learning-tool.png";
import Bubble from "../../assets/speech-bubble_blue.png";
import Char from "../../assets/character.png";
import QuizButton from "./QuizButton";
import { useSelector, useDispatch } from "react-redux";
import { unsetScore } from "../../features/scoreCounter/scoreSlice";
import Swal from "sweetalert2";

function Quiz() {
  const navigate = useNavigate();
  const { score } = useSelector((state) => state.score);
  const dispatch = useDispatch();

  useEffect(() => {
    if (score > 0) {
      dispatch(unsetScore());
    }
  }, []);

  const handleNext = () => {
    if (score === 0) {
      Swal.fire({
        icon: "error",
        title: "No boxes selected",
        text: "Please select the boxes if you answer YES to them",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      return;
    } else {
      navigate("/results/En");
    }
  };

  const handleLanguage = () => {
    navigate("/Fil");
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={3} className="left-card">
          <Box className="img-container">
            <img src={Logo} alt="Logo" className="logo-img" />
          </Box>
          <Box sx={{ marginBottom: ".5rem" }}>
            <Button
              sx={{
                backgroundColor: "#1ec2f0",
                color: "#fff",
                fontSize: "1.2rem",
                textTransform: "none",
                padding: ".7rem",
                borderRadius: "1.5rem",
                "&:hover": {
                  backgroundColor: "#1ec2f0", // Set it to the same value as the default
                },
              }}
              onClick={() => handleLanguage()}
            >
              To Filipino Ver.
            </Button>
          </Box>
          <Box className="instruction-card">
            <p className="instruction-title">Activity Instructions</p>
            <p className="instruction-text">
              Take a quiz to help you determine your level of empowerment as a
              financial customer.
            </p>
            <p className="instruction-text">
              On the right side is a series of questions that reflect knowledge,
              attitude and actions associated with a financial journey.
            </p>
            <p className="instruction-text">
              Click on the item if you answer Yes to the question.
            </p>
            <p className="instruction-text">
              Once completed with answering the questions, click on the Next
              button.
            </p>
          </Box>
        </Grid>
        <Grid item xs={12} md={9} className="right-card">
          <Grid container>
            <Grid item xs={12} md={9}>
              <Box className="right-card-header">
                <Box className="img-container-bubble">
                  <p className="header-title">
                    Are you an Empowered Customer ?
                  </p>
                  <img src={Bubble} alt="bubble" className="bubble-img" />
                </Box>
              </Box>
              <Box className="item-container">
                <QuizButton>
                  Do you know what choices are available in the market?
                </QuizButton>
                <QuizButton>
                  Are you aware of and able to use feedback/ complaints
                  mechanisms?
                </QuizButton>
                <QuizButton>
                  Do you know what to expect from a provider?
                </QuizButton>
                <QuizButton>
                  Do you understand how to use financial services for a purpose?
                </QuizButton>
                <QuizButton>
                  Are you confident in your ability to choose?
                </QuizButton>
                <QuizButton>
                  Are you willing to give feedback or complaint?
                </QuizButton>
                <QuizButton>
                  Do you expect good treatment from financial service providers
                  and staff?
                </QuizButton>
                <QuizButton>
                  Do you feel capable to use financial services?
                </QuizButton>
                <QuizButton>
                  Do you make comparisons between available products and
                  services in the market?
                </QuizButton>
                <QuizButton>
                  Do you give feedback and make complaints when relevant?
                </QuizButton>
                <QuizButton>
                  Have you felt being treated with respect by service providers?
                </QuizButton>
                <QuizButton>
                  Do you take up and use appropriate financial services?
                </QuizButton>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  flexDirection: "column",
                }}
              >
                <Box className="img-container">
                  <img src={Char} alt="Char" className="logo-img" />
                </Box>
                <Button className="quiz-button" onClick={() => handleNext()}>
                  Next
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Quiz;
